namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_viewport_frame_number, {
		
		align: {
			self: 'flex-end',
		},

		Items: {
			maxWidth: '210px',
			flex: {
				wrap: 'wrap',
			},
		},

		Option_row: {
			justify: {
				content: 'center',
			},
		},
		Trigger: {
			justify: {
				content: 'center',
			},
		},

		
	} )
	
}
